import {useFetchData} from 'hooks/api/useFetchData'
import {ProcedureCsvSerialNumber} from 'types/api/procedureCsvSerialNumbers/procedureCsvSerialNumber'

export const useFetchProcedureCsvSerialNumbers = (clientId: number) => {
  const path = `/api/clients/${clientId}/procedure_csv_serial_numbers`

  return useFetchData<ProcedureCsvSerialNumber | undefined>(path, undefined, {immediate: false})
}
